import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import type { CSSProperties, ReactNode } from 'react';

import type { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Bezel } from '@sorare/core/src/atoms/ui/bezels/Bezel';

import { findRewardThresholdColor } from '#src/lib/wheelReward.ts';

import type { Shape_probabilisticBundleSlotConfig } from './__generated__/index.graphql.ts';

type Props = {
  config: Shape_probabilisticBundleSlotConfig;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  rarity: Rarity;
};

export const Shape = ({
  config,
  children,
  className,
  style,
  rarity,
}: Props) => {
  const color = findRewardThresholdColor(config, rarity);

  return (
    <Bezel
      bezelSize={20}
      radius={16}
      borderWidth={2}
      borderColor={`linear-gradient(to bottom, var(--c-nd-100) 20%, ${color} 100%)`}
      background={`${color} conic-gradient(from 90deg at 4px 4px, var(--c-nl-800) 25%, var(--c-black) 0) 0 0/5px 5px`}
      boxShadow={`inset 0px -20px 20px -20px ${color}`}
      style={{ ...style, padding: '0 8px', height: '100%' }}
      className={className}
    >
      {children}
    </Bezel>
  );
};

Shape.fragments = {
  ProbabilisticBundleSlotConfig: gql`
    fragment Shape_probabilisticBundleSlotConfig on ProbabilisticBundleSlotConfig {
      id
      ...findRewardThresholdColor_probabilisticBundleSlotConfig
    }
    ${findRewardThresholdColor.fragments.probabilisticBundleSlotConfig}
  ` as TypedDocumentNode<Shape_probabilisticBundleSlotConfig>,
};
